<script setup lang="ts">
import { ref } from "vue";

import { api } from "@/lib/api.js";
import { startSession } from "@/lib/session.js";

const username = ref("");
const password = ref("");
const busy = ref(false);
const error = ref("");

async function submit(): Promise<void> {
  if (busy.value) return;

  busy.value = true;
  error.value = "";

  try {
    const result = await api.login(username.value, password.value);
    startSession(result.token, result.user);
  } catch (loginError) {
    error.value = loginError instanceof Error ? loginError.message : "Sisselogimine ebaõnnestus.";
  } finally {
    busy.value = false;
  }
}
</script>

<template>
  <main class="wrap">
    <form class="card" @submit.prevent="submit">
      <p class="eyebrow">Sisemine tööriist</p>
      <h1>mAImu</h1>
      <p class="lead">JahiKala sisemine assistent. Logi sisse oma kasutajaga.</p>

      <label for="username">Kasutajanimi</label>
      <input id="username" v-model="username" autocomplete="username" autofocus required />

      <label for="password">Parool</label>
      <input id="password" v-model="password" type="password" autocomplete="current-password" required />

      <p v-if="error" class="error">{{ error }}</p>

      <button class="btn-primary" type="submit" :disabled="busy">
        {{ busy ? "Login sisse…" : "Logi sisse" }}
      </button>
    </form>
  </main>
</template>

<style scoped>
.wrap {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 1.5rem;
}

form {
  width: min(24rem, 100%);
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  border-top: 3px solid var(--gold);
}

.eyebrow {
  margin: 0;
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--gold-dark);
}

h1 {
  margin: 0.15rem 0 0;
  font-size: 1.9rem;
  letter-spacing: -0.02em;
}

.lead {
  margin: 0 0 1rem;
  color: var(--muted);
  font-size: 0.9rem;
}

label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--steel);
  margin-top: 0.5rem;
}

.error {
  margin: 0.6rem 0 0;
  color: var(--warn);
  font-size: 0.85rem;
}

button {
  margin-top: 1.1rem;
}
</style>
